import { Product } from '../types/Product';

export interface WarehouseStockSnapshot {
  sizeQuantities?: Record<string, number>;
  location?: string;
  receivedDate?: Date | string;
  stockQuantity?: number;
}

export const getWarehouseStockSnapshot = (product: Product): WarehouseStockSnapshot => {
  const stockInfo = product.stockInfo;
  const legacyWarehouseInfo = product.warehouseInfo;

  return {
    sizeQuantities: stockInfo?.sizeQuantities ?? legacyWarehouseInfo?.sizeQuantities,
    location: stockInfo?.location ?? legacyWarehouseInfo?.location,
    receivedDate: stockInfo?.receivedDate ?? legacyWarehouseInfo?.receivedDate ?? legacyWarehouseInfo?.receivedAt,
    stockQuantity: stockInfo?.countedQuantity ?? legacyWarehouseInfo?.stockQuantity
  };
};
